import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';

@Component({
    templateUrl: './client-portal-client-referral-task-reports.component.html',
    imports: [ReportsComponent]
})
export class ClientPortalClientReferralTaskReportsComponent {
  reportsUrl = `${environment.captureApi.url}/client_referral_task_reports`;

  constructor() {}
}
